module.exports = __webpack_public_path__ + "img/p3_1.758ad21f.png";